<template>
  <div class="analysis-images-gallery">
    <div class="analysis-images-gallery-grid">
      <div
        class="image-thumb-holder"
        v-for="(image, i) in imagesToDisplay"
        :key="i"
      >
        <img
          :src="image"
          @click="openGallery(getActualImageIndex(i))"
          alt=""
          class="image-thumb"
        />
      </div>
    </div>

    <div class="actions mt-1" v-if="totalImages > perPage">
      <div
        class="prev btn btn-info px-1 py-0"
        :class="{ disabled: page <= 0 }"
        @click="handlePrev"
      >
        &lt;&lt;
      </div>
      <div
        class="next btn btn-info px-1 py-0 ml-1"
        :class="{ disabled: isPageLast }"
        @click="handleNext"
      >
        &gt;&gt;
      </div>
    </div>

    <div class="mt-3"><b>Total imagens:</b> {{ images.length }}</div>
  </div>
</template>

<script>
  export default {
    emits: ['open-gallery'],
    props: {
      images: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data() {
      return {
        page: 0,
        perPage: 4,
        totalImages: 0,
      }
    },
    methods: {
      openGallery(imageIndex) {
        this.$emit('open-gallery', {
          images: this.images,
          index: imageIndex,
        })
      },
      getActualImageIndex(offset) {
        const pageStart = this.page * this.perPage
        return pageStart + offset
      },
      handlePrev() {
        if (this.page > 0) this.page = this.page - 1
      },
      handleNext() {
        if (!this.isPageLast) this.page = this.page + 1
      },
    },
    computed: {
      isPageLast() {
        //Page é 0-indexed, desta forma...
        //Se a divisão de total_de_imagens por qtd_por_pagina não for exata, considerar a página atual
        //Caso contrário, deve ser considerada a próxima página
        //Ex: total = 14, perPage = 4, página 3 (última) -> floor(14/4) = 3
        //Ex2: total = 12, perPage = 4, página 2 (última) -> floor(12/4) = 3
        return (
          Math.floor(this.totalImages / this.perPage) === this.page ||
          (Math.floor(this.totalImages / this.perPage) === this.page + 1 &&
            this.totalImages % this.perPage === 0)
        )
      },
      imagesToDisplay() {
        const pageStart = this.page * this.perPage
        const lastPageItem = pageStart + this.perPage

        return this.images.slice(pageStart, lastPageItem)
      },
    },
    mounted() {
      this.totalImages = this.images.length
    },
  }
</script>

<style lang="scss" scoped>
  .analysis-images-gallery {
    min-width: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .analysis-images-gallery-grid {
      text-align: center;
      display: grid;
      grid-template-columns: 60px 60px;
      gap: 5px;

      .image-thumb-holder {
        width: 60px;
        height: 60px;
        display: inline-block;

        .image-thumb {
          width: 100%;
          height: 100%;
          object-fit: cover;

          cursor: pointer;
        }
      }
    }

    .actions {
      display: flex;
      justify-content: space-between;

      height: 30px;

      .btn {
        font-weight: bold;
      }
    }
  }
</style>
